export class AuraOperationsApiError extends Error {
  constructor(
    message: string,
    public statusCode: number,
  ) {
    super(message);
    this.name = 'AuraOperationsApiError';
  }
}
